module.exports = __webpack_public_path__ + "img/fart-cloud-3.e3c6dd1b.png";